import type { FC } from "react";
import Button from "react-bootstrap/Button";
import { useTranslation, Trans } from "react-i18next";
import TutoringColor from "images/achievements/80-doucko.svg?url";

import { Lightbox } from "components/Lightbox";

interface Props {
  onClose: () => void;
}

export const FixedAssignmentsFinishedModal: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation("tutoring");

  return (
    // Nadpis je vždy přítomný, zůstává proto v těle a jen pojmenuje dialog. [TD-344]
    <Lightbox
      show={true}
      onHide={onClose}
      bodyClassName="d-flex flex-column align-items-center justify-content-center gap-3 text-center"
      bodyTitleId="fixed-assignments-finished-title"
      // AIDEV-NOTE: `Modal.Footer` nemá přes `Lightbox` cestu na vlastní `className`
      // (`footer` prop obaluje jen obsah) — `mx-auto` na tlačítku samotném dosáhne
      // stejného centrování ve výchozím `justify-content: flex-end` patičky. [TD-344]
      footer={
        <Button variant="azure" onClick={onClose} className="px-5 mx-auto">
          <div className="px-3 text-nowrap">{t("doneModal.button")}</div>
        </Button>
      }
    >
      {/* Velikost drží `.fs-16`, ať se sjednocením na `h2` (globálně 17 px) nezmění
          vzhled — původní `h4` měl 16 px ($h4-font-size). [TD-344] */}
      <h2 id="fixed-assignments-finished-title" className="fs-16">
        {t("doneModal.title")}
      </h2>
      <img src={TutoringColor} alt="" />
      <div>
        <Trans
          i18nKey="doneModal.text"
          ns="tutoring"
          components={{
            strong: <strong />,
          }}
        />
      </div>
    </Lightbox>
  );
};
